<p class="card-facts__title" *ngIf="title">{{ title }}</p>
<dl class="card-facts">
  <div class="card-facts__row" *ngFor="let item of items; trackBy: trackFact">
    <dt class="card-facts__label">{{ item.label }}</dt>
    <dd class="card-facts__value">{{ item.value }}</dd>
  </div>
</dl>
